// @ vendors
const { APIPost, APIGet } = require('utilities/APIRequestHelper');
const get = require('lodash/object/get');
const momentTz = require('moment-timezone');

const Immutable = require('immutable');
const trim = require('lodash/string/trim');
const translateExantCostKey = require('utilities/translationExantCost');
const { formatWithoutRound } = require('utilities/currencyHelper');

// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
const { formatText } = require('core/i18n').i18n;

// @ actions
const errorActions = require('actions/brokerError');
const signaturePatternActions = require('actions/signaturePattern');
const { outdateGlobalPosition } = require('actions/myGlobalPosition');
const { outdateMyInvestments } = require('actions/brokerMyInvestments');
const { searchSpecificIsin } = require('actions/brokerProductAdvancedSearch');

// @utils
const PersonalDataHelper = require('utilities/personalDataHelper');

// @ constants
const actionTypes = require('constants/actionTypes');
const {
    BROKER_INVESTMENT_FUNDS_PRODUCT_URL_PARAMETER,
    BROKER_REIMBURSE_FUND_TOTAL,
    FIRST_STEP,
    BROKER_RED_FUND,
    BROKER_MIFID_FUND_RED,
    BROKER_YELLOW_FUND,
    BROKER_MIFID_FUND_YELLOW,
    BROKER_GREEN_FUND,
    BROKER_MIFID_FUND_GREEN,
    CHARGE_ACCOUNT_PREFIX,
    BROKER_ORDER_TYPE_SELL,
    CONNECTION_CHANNEL_INTERNET,
    INTERVENER_TYPE_TITULAR,
    BROKER_PRODUCT_TYPE_FUNDS_ES,
    BROKER_REIMBURSE_FUND_PARTICIPATION
} = require('constants/index');
const {
    NOT_ALLOWED_WEALTH_FUNDS_SELL_SHOW_COST_COUNTRIES,
    WEALTH_FUNDS_PARTIAL_REIMBURSEMENT
} = require('constants/flagBasedFeatures');
const { es: { DATE_FORMAT_WITH_DASHES_DATETIME }} = require('commonsConstants/dateFormatTypes');

const requestReimburseFundsInProgress = () => ({
    type: actionTypes.FETCH_BROKER_REIMBURSE_INVESTMENT_REQUEST,
});

const requestMorningStarScreenerInProgress = () => ({
    type: actionTypes.FETCH_BROKER_MORNINGSTAR_SCREENER_REQUEST
});

const requestMorningStarScreenerSuccess = (dataMorningStar, dataMorningStarDetail) => ({
    type: actionTypes.FETCH_BROKER_MORNINGSTAR_SCREENER_SUCCESS,
    payload: {
        reimburseInvestment: dataMorningStar,
        securityDetails: dataMorningStarDetail
    }
});

const requestMorningStarScreenerFailure = error => ({
    type: actionTypes.FETCH_BROKER_MORNINGSTAR_SCREENER_FAILURE,
    payload: {
        error
    }
});

const requestReimburseInvestmentFailure = error => ({
    type: actionTypes.FETCH_BROKER_REIMBURSE_INVESTMENT_FAILURE,
    payload: {
        error
    }
});

const requestInvestmentFundsNotFound = () => ({
    type: actionTypes.FETCH_BROKER_REIMBURSE_INVESTMENT_NOT_FOUND,
    payload: {
        error: formatText('brokerHireInvestmentStep1-nonExistingFund')
    }
});

const requestReimburseNewOrderSuccess = ({data, productNumber, contractNumber, account, fundControlDigit, totalAmount, hasActiveContribution}) => ({
    type: actionTypes.FETCH_BROKER_REIMBURSE_NEW_ORDER_SUCCESS,
    payload: {
        reimburseOrder: data,
        productNumber: productNumber,
        contract: contractNumber,
        account,
        fundControlDigit,
        totalAmount,
        hasActiveContribution
    }
});

const requestReimburseNewOrderFailure = error => ({
    type: actionTypes.FETCH_BROKER_REIMBURSE_NEW_ORDER_FAILURE,
    payload: {
        error
    }
});

const setVisibleStep = step => ({
    type: actionTypes.BROKER_WIZARD_REIMBURSE_FUND_SET_VISIBLE_STEP,
    payload: {
        step
    }
});

const setWillLeave = () => ({
    type: actionTypes.BROKER_WIZARD_REIMBURSE_FUND_WILL_LEAVE
});

//TODO: Add a confirmation when a user click con Cancel.
const setWillCancel = willCancel => ({
    type: actionTypes.BROKER_WIZARD_REIMBURSE_FUND_WILL_CANCEL,
    payload: {
        willCancel
    }
});

const validateStep = step => ({
    type: actionTypes.BROKER_WIZARD_REIMBURSE_FUND_VALIDATE_STEP,
    payload: {
        step
    }
});

const setReimburseType = amountValues => ({
    type: actionTypes.BROKER_WIZARD_REIMBURSE_FUND_SET_TYPE,
    payload: amountValues
})

const changeType = type => (dispatch) => {
    const amountValues = {
        type: type,
        amount: 0
    }

    dispatch(setReimburseType(amountValues))
};


const setAmount = amount => ({
    type: actionTypes.BROKER_WIZARD_REIMBURSE_FUND_SET_AMOUNT,
    payload: {
        amount
    }
});

const setParticipation = (value, amount) => ({
    type: actionTypes.BROKER_WIZARD_REIMBURSE_FUND_SET_PARTICIPATION,
    payload: {
        participation: value,
        participationAmount: amount
    }
});

const reimburseFundConfirmationSuccess = data => ({
    type: actionTypes.BROKER_WIZARD_REIMBURSE_FUND_POST_SUCCESS,
    payload: {
        data
    }
});

const reimburseFundConfirmationFailure = error => ({
    type: actionTypes.FETCH_BROKER_REIMBURSE_FUND_ADD_FAILURE,
    payload: {
        error
    }
});

const getType = immReimburseInvestment => {
    return immReimburseInvestment.getIn(['steps', FIRST_STEP, 'type']) === BROKER_REIMBURSE_FUND_TOTAL
        ? 'T'
        : 'P';
};

const reset = () => ({
    type: actionTypes.BROKER_WIZARD_REIMBURSE_FUND_RESET
});

const getIntervenersSuccess = data => ({
    type: actionTypes.FETCH_BROKER_GET_INTERVENERS_SUCCESS,
    payload: {
        data
    }
});

const getInterveners = (reimburseFund) => (dispatch) => {
    const immAccount = reimburseFund.account;
    const contractNumber = immAccount.contractNumber;
    const productNumber = immAccount.product;

    const requestData = {
        query: {
            producto: productNumber,
            numeroContrato: contractNumber
        }
    };

    return APIGet(dispatch, apiURLBuilder.getURL('brokerGetIntervenersInvestment'), requestData)
        .then(response => dispatch(getIntervenersSuccess(response)))
};

const findFundMiFIDID = (fundType) => {
    let fundMifidId;
    switch (fundType) {
        case BROKER_RED_FUND:
            fundMifidId = BROKER_MIFID_FUND_RED;
            break;
        case BROKER_YELLOW_FUND:
            fundMifidId = BROKER_MIFID_FUND_YELLOW;
            break;
        case BROKER_GREEN_FUND:
            fundMifidId = BROKER_MIFID_FUND_GREEN;
            break;
    }
    return fundMifidId;
}

const generateMiFIDDisclaimers = (immBrokerConvenienceMiFIDTest) => {
    const immUSPersonDisclaimers = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'usPersonDisclaimers']);
    const immDisclaimers = immBrokerConvenienceMiFIDTest.getIn(['mifidv2', 'disclaimers']);
    const immAllDisclaimers = Immutable.fromJS([]).merge(immUSPersonDisclaimers).merge(immDisclaimers);

    return immAllDisclaimers.map((immDisclaimer, index) => {
        const disclaimer = index === 0 && immDisclaimer.get('phrase')
        ? `${immDisclaimer.get('description')} ${immDisclaimer.get('phrase')}`
        : immDisclaimer.get('description')
        return disclaimer
    }).join(' | ');
};

const getHolders = (interveners) => {
    let holderNames = [];
    holderNames = interveners.filter((intervener) => {
        return intervener.get('type').trim() === INTERVENER_TYPE_TITULAR
    }).map(holder => {
        return holder.get('name').trim()
    });
    return holderNames;
}

function sendExAnteOrderRequest(){
    return {
        type: actionTypes.BROKER_WIZARD_REIMBURSE_FUND_DOCUMENT_STORAGE_REQUEST
    }
}

function sendExAnteOrderSuccess() {
    return {
        type: actionTypes.BROKER_WIZARD_REIMBURSE_FUND_DOCUMENT_STORAGE_SUCCESS
    };
}

function sendExAnteOrderError() {
    return {
        type: actionTypes.BROKER_WIZARD_REIMBURSE_FUND_DOCUMENT_STORAGE_ERROR
    };
}


const sendExAnteOrder = (orderResponse) => (dispatch, getState) => {
    const immProfile = getState().profile;
    const immReimburseInvestment = getState().reimburseInvestment;

    const immStep = immReimburseInvestment.getIn(['steps', FIRST_STEP])

    const fundControlDigit = immStep.getIn(['reimburseFund', 'controlDigit']);
    const fundProductNumber = immStep.getIn(['reimburseFund', 'productNumber']);
    const fundContractNumber = immStep.getIn(['reimburseFund', 'contractNumber']);
    const emittedDateTime = momentTz(parseInt(get(orderResponse, 'timestamp', ''), 10)).tz("Europe/Madrid");
    const ccv = trim(
        CHARGE_ACCOUNT_PREFIX +
        fundControlDigit +
        fundProductNumber +
        fundContractNumber
    );
    const ccc = immStep.getIn([
        "reimburseFund",
        "account",
        "fullContractNumber",
    ]);
    const exAnteCostsList = translateExantCostKey(immReimburseInvestment.get('exAnteCostList').toJS(), 'reimburseInvestmentDetailsWithCosts');
    const currencyFund = immStep.getIn(['reimburseFund', 'currencyFund']);
    const interveners = immReimburseInvestment.get('interveners');
    const holderNames = getHolders(interveners);
    const isin = immStep.getIn(['reimburseInvestment', 'isin']);
    const isinDescribe = immStep.getIn(['reimburseInvestment', 'name']);
    const type = immStep.get('type');
    let importMov;
    if (type === 'total') {
        const immFund = getState().brokerMyInvestments.getIn(['products', 'funds', 'stocks']).find(fund =>
            fund.get('producto') === fundProductNumber &&
            fund.get('numerodecontrato') === fundContractNumber
        );
        importMov = formatWithoutRound(immFund.get('totalValue'),2)
    } else {
        importMov = formatWithoutRound(immStep.get('amount'), 2);
    }

    const communicationServiceInput = {
        boletinAdhesion:'',
        ccv: ccv,
        ccc: ccc,
        channel: CONNECTION_CHANNEL_INTERNET,
        clientAlias: immProfile.get('nombreCliente'),
        cnmvCommunication: '',
        conditionPrize: '',
        contract: '',
        costBreakdown: '',
        exAnteCostsList: exAnteCostsList,
        costYield: '',
        currency: currencyFund,
        dateTime: emittedDateTime.format(DATE_FORMAT_WITH_DASHES_DATETIME),
        depreciation: '',
        economicReport: '',
        email: PersonalDataHelper.getEmail(immProfile),
        holders: holderNames.join(','),
        idContract: ccv,
        idOrder: '',
        infoCcv: '',
        isin: isin,
        isinDescribe: isinDescribe,
        leafletSusbcription: '',
        market: '',
        marketingReport: '',
        message: '',
        mifidWarningText: generateMiFIDDisclaimers(
            getState().brokerConvenienceMiFIDTest
        ),
        orderCondition:'',
        orderType: BROKER_ORDER_TYPE_SELL,
        originFund: '',
        productKID: '',
        productType: BROKER_PRODUCT_TYPE_FUNDS_ES,
        sendOrder: 'No',
        termValidity: '',
        importMov: importMov,
        sharesAmount: importMov,
    };

    const data = {
        query: communicationServiceInput,
    };

    dispatch(sendExAnteOrderRequest());

    return APIPost(
        dispatch,
        apiURLBuilder.getURL("communicationServiceMail"),
        data
    )
        .then(() => {
            dispatch(sendExAnteOrderSuccess());
        })
        .catch(() => {
            dispatch(sendExAnteOrderError());
        });
}

const reimburseFundConfirmation = (dispatch, getState, immReimburseInvestment, dataToken, history) => {
    const immFlagBasedFeatures = getState().flagBasedFeatures;
    const reimburseFund = immReimburseInvestment.getIn(['steps', FIRST_STEP, 'reimburseFund']).toJS();
    const amount = immReimburseInvestment.getIn(['steps', FIRST_STEP, 'amount']);
    const type = getType(immReimburseInvestment);
    const fundType = immReimburseInvestment.getIn(['steps', FIRST_STEP, 'reimburseInvestment', 'customCategoryId3']);
    const FundMiFID = findFundMiFIDID(fundType);
    const codigoDisclaimer = getState().brokerMiFIDProducts.getIn(['products', FundMiFID, 'codigoDisclaimer']);
    const unitPrice = immReimburseInvestment.getIn(['steps', FIRST_STEP, 'reimburseInvestment', 'netAssetValue', 'amount']);
    const isinId = immReimburseInvestment.getIn(['steps', FIRST_STEP, 'reimburseInvestment', 'isin']);

    const immBrokerMyInvestments = getState().brokerMyInvestments;
    const funds = immBrokerMyInvestments.getIn(['products','funds','stocks']);
    const selectedFund = funds.filter(stock => stock.get('isin') == isinId);

    let shares = 0;

    if (type === 'T') {
        shares = selectedFund.size == 0 ? 0 : selectedFund.getIn([0,'totalOperations','shares']);
    } else {
        shares = amount / parseFloat(unitPrice);
    }
    const ffFundsPartialReimbursement = getState().flagBasedFeatures.get(WEALTH_FUNDS_PARTIAL_REIMBURSEMENT);
    const customCategoryId2 = immReimburseInvestment.getIn(['steps', FIRST_STEP, 'reimburseInvestment', 'customCategoryId2']);
    const modOP =
      ffFundsPartialReimbursement && customCategoryId2 === '2' && type === 'P'
        ? BROKER_REIMBURSE_FUND_PARTICIPATION
        : type === 'T'
        ? type
        : 'I';
    const postData = {
            dataToken: dataToken,
            entradaReembolso: {
                codIdioma: 'E',
                codMonCuenta: reimburseFund.currencyFund,
                codSubtipoProduc: reimburseFund.ProductSubTypeCode,
                codmonr: reimburseFund.currencyFund,
                cuentaDomi: {
                    numerodecuenta: reimburseFund.accountNumber,
                    digitodecontrol: reimburseFund.controlDigit
                },
                fechValorLiq: reimburseFund.netAssetValueDate,
                modOP: modOP,
                saldoParticipaciones: reimburseFund.saldoParticipaciones,
                tipo: 'RE',
                tipoReembolso: type,
                valorLiquid: {
                    divisa: reimburseFund.lastNetAssetValue.currency,
                    valorliquidativo: reimburseFund.lastNetAssetValue.amount
                }
            },
            entradaSeguridad: {
                contrato: {
                    numerodecontrato: reimburseFund.contractNumber,
                    producto: reimburseFund.productNumber
                }
            },
            "convenienceTest": codigoDisclaimer,
            "initQuantity": shares,
            "productIsin": isinId,
            "productManager": '',
            "unitPrice": unitPrice,
            "micCode": "",
            "disclaimers": {
                "disclaimer_1": "",
                "disclaimer_2": "",
                "disclaimer_3": "",
                "disclaimer_4": "",
                "disclaimer_5": ""
            },
            "convenientRegistry": false,
            "evaluateRegistry": false,
            "marketTargetRegistry": false,
            "necessaryConvenienceTestNote": 0,
            "necessaryTargetMarketNote": "",
            "testConveniencyResult": 0
    };

    const requestData = {
        header: {
            version: 2
        },
        query: postData
    };

    if (amount > 0 && type !== 'T') {
        postData.entradaReembolso.importMov = amount;
    }

    dispatch(requestReimburseFundsInProgress());
    return APIPost(dispatch, apiURLBuilder.getURL('brokerReimburseFundConfirmation'), requestData)
        .then(
            response => {
                dispatch(reimburseFundConfirmationSuccess(response));
                if (immFlagBasedFeatures.get(NOT_ALLOWED_WEALTH_FUNDS_SELL_SHOW_COST_COUNTRIES)) {
                    dispatch(sendExAnteOrder(response));
                }
                dispatch(outdateGlobalPosition());
                dispatch(outdateMyInvestments());
            },
            function(response) {
                dispatch(reimburseFundConfirmationFailure(response));
                const errorKey = get(response, ['body', 'error'], '');
                dispatch(errorActions.show('brokerAPIErrors-' + errorKey, true, history));
            }
        )
        .catch(response => {
            dispatch(reimburseFundConfirmationFailure(response));
            const errorKey = get(response, ['body', 'error'], '');
            dispatch(errorActions.show('brokerAPIErrors-' + errorKey, true, history));
        });
};

const reimburseInvestmentFund = (immReimburseInvestment, history) => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        reimburseFundConfirmation(dispatch, getState,immReimburseInvestment, dataToken, history);
    };
    const isAlreadyFetching = immReimburseInvestment.get('isFetching');

    if (!isAlreadyFetching) {
        new Promise(function() {
            signaturePatternActions.validateAndExecute(dispatch, getState, callback);
        });
    }
};

const getReimburseNewOrder = (fundId, contractNumber) => (dispatch, getState) => {
    const productNumber = fundId.substring(0, 3);
    const immAccounts = getState().accounts;
    const immFund = getState().brokerMyInvestments.getIn(['products', 'funds', 'stocks']).find(fund =>
        fund.get('producto') === productNumber &&
        fund.get('numerodecontrato') === contractNumber
    );
    const contributionList = getState().brokerMyInvestments.getIn(['fundsContributionsList', "list", "recurringTransfers"])
    const fundContibution = contributionList?.find(contrib => contrib.get('contractCode') === contractNumber && contrib.get('productId') === productNumber);
    const requestData = {
        query: {
            numeroContrato: contractNumber,
            producto: productNumber,
            isin: immFund.get('isin')
        }
    };
    return APIGet(dispatch, apiURLBuilder.getURL('brokerReimburseFund'), requestData)
        .then(response => {
            const actualAccount = immAccounts
                .get('byId')
                .filter(
                    account =>
                        account.getIn(['ibanComplex', 'codbban']) ===
                        response.cuentaDomi.codbban.trim()
                )
                .toJS();
            const fundControlDigit = immFund ? immFund.get('controlDigit') : '';
            const successData = {
                data: response,
                productNumber: productNumber,
                contractNumber: contractNumber,
                account: actualAccount,
                fundControlDigit: fundControlDigit,
                totalAmount: 0,
                hasActiveContribution: fundContibution?.size > 0 ? true : false,
            };
            dispatch(
                requestReimburseNewOrderSuccess(successData)
            );
        })
        .catch(response => dispatch(requestReimburseNewOrderFailure(response.error)));
};

const getReimburseExAntDetailsFetching = () => ({
    type: actionTypes.FETCH_BROKER_REIMBURSE_EX_ANTE_DETAILS_REQUEST,
});

const getReimburseExAntDetailsSuccess = (exAntDetails) => ({
    type: actionTypes.FETCH_BROKER_REIMBURSE_EX_ANTE_DETAILS_SUCCESS,
    payload: {
        exAntDetails,
    }
});

const getReimburseExAntDetailsFailure = () => ({
    type: actionTypes.FETCH_BROKER_REIMBURSE_EX_ANTE_DETAILS_FAILURE,
});

const getReimburseExAntDetails = (fundId, contractNumber) => (dispatch, getState) => {
    const productNumber = fundId.substring(0, 3);
    const immReimburseInvestment = getState().reimburseInvestment;
    const immFund = getState().brokerMyInvestments.getIn(['products', 'funds', 'stocks']).find(fund =>
        fund.get('producto') === productNumber &&
        fund.get('numerodecontrato') === contractNumber
    );
    const type = immReimburseInvestment.getIn(['steps', FIRST_STEP, 'type']);
    let amount, currency;
    const accountId = immReimburseInvestment.getIn(['steps', 0, 'reimburseFund', 'account', 'accountId']);
    const immAccounts = getState().accounts;
    const immAccount = immAccounts.getIn(['byId', accountId]);
    currency = immAccount.getIn(['balance', 'currency']);
    if (type === 'total') {
        if (currency === immFund.get('totalValueCurrency')) {
            amount = immFund.get('totalValue')
        } else {
            if (immFund.get('totalValueEur')) {
                amount = immFund.getIn(['totalValueEur', 'amount']);
                currency = immFund.getIn(['totalValueEur', 'currency']);
            } else {
                amount = immFund.get('totalValue');
                currency = immFund.get('totalValueCurrency');
            }
        }
    } else {
        const ffFundsPartialReimbursement = getState().flagBasedFeatures.get(WEALTH_FUNDS_PARTIAL_REIMBURSEMENT);
        const customCategoryId2 = immReimburseInvestment.getIn(['steps', FIRST_STEP, 'reimburseInvestment', 'customCategoryId2']);
        if(ffFundsPartialReimbursement && customCategoryId2 === '2') {
            amount = immReimburseInvestment.getIn(['steps', FIRST_STEP, 'participationAmount']);
        } else {
            amount = immReimburseInvestment.getIn(['steps', FIRST_STEP, 'amount']);
        }

    }
    const requestData = {
        header: {
            version: 2,
        },
        query: {
            numeroContrato: contractNumber,
            producto: productNumber,
            isin: immFund.get('isin'),
            importe: {
                amount: amount,
                currency: currency
            }
        }
    };
    dispatch(getReimburseExAntDetailsFetching());
    return APIPost(
        dispatch,
        apiURLBuilder.getURL("brokerReimburseFund"),
        requestData
    )
        .then((response) => {
            const exAnteDetails = response.exAnteCostList;
            dispatch(getReimburseExAntDetailsSuccess(exAnteDetails));
        })
        .catch((response) => {
            dispatch(getReimburseExAntDetailsFailure());
            dispatch(requestReimburseNewOrderFailure(response.error));
        });
}

const getMorningStarScreenerSecurityDetails = dataMorningStar => (dispatch, getState) => {
    const typeId = BROKER_INVESTMENT_FUNDS_PRODUCT_URL_PARAMETER;
    const requestData = {
        query: {
            viewId: 'price',
            LanguageId: 'es-ES',
            responseViewFormat: 'json'
        }
    };
    return APIGet(
        dispatch,
        apiURLBuilder.getURL('brokerGetMorningStarScreenerSecurityDetails', {
            type: typeId,
            id: dataMorningStar.rows[0].SecId
        }),
        requestData
    )
        .then(response => dispatch(requestMorningStarScreenerSuccess(dataMorningStar, response)))
        .then(() => {
            const immReimburseInvestment = getState().reimburseInvestment;
            const isinCode = immReimburseInvestment.getIn(['steps', 0, 'reimburseInvestment', 'isin']);
            dispatch(searchSpecificIsin(isinCode));
        })
        .catch(response => dispatch(requestMorningStarScreenerFailure(response.error)));
};

const getMorningStarScreener = product => (dispatch, getState) => {
    const immReimburseInvestment = getState().reimburseInvestment;

    if (!immReimburseInvestment.get('fetchSuccess') && !immReimburseInvestment.get('isFetching')) {
        const typeId = BROKER_INVESTMENT_FUNDS_PRODUCT_URL_PARAMETER;

        const requestData = {
            query: {
                securityDataPoints:
                    'SecId|ISIN|Name|CustomCategoryIdName|CustomMinimumPurchaseAmount|CustomMinimumPurchaseAmountUnit|CustomInstitutionSecurityId|ReturnM0',
                pageSize: 5000,
                outputType: 'json',
                languageId: 'es-ES',
                currencyId: 'EUR',
                universeIds: 'FOEUR$$ALL_2118',
                filters: `CustomInstitutionSecurityId:EQ:${product}`
            }
        };

        dispatch(requestMorningStarScreenerInProgress());
        return APIGet(
            dispatch,
            apiURLBuilder.getURL('brokerGetMorningStarScreener', { type: typeId }),
            requestData
        )
            .then(response => {
                !!response.rows.length
                    ? dispatch(getMorningStarScreenerSecurityDetails(response))
                    : dispatch(requestInvestmentFundsNotFound());
            })
            .catch(response => dispatch(requestReimburseInvestmentFailure(response.error)));
    }
};

module.exports = {
    setVisibleStep,
    setWillCancel,
    setWillLeave,
    setAmount,
    setParticipation,
    validateStep,
    reimburseInvestmentFund,
    changeType,
    getMorningStarScreener,
    getReimburseNewOrder,
    getInterveners,
    reset,
    getReimburseExAntDetails
};

